<template>
  <div class="bg-gray-100 rounded-md tw-p-3 text-sm line-height-tight">

    <div class="d-flex tw-gap-2 tw-mb-2 align-items-center font-semibold text-md">
      <div class="size-6 do-svg-full" title="" v-html="accessoryInfo.logo"></div>
      <span> {{ accessoryInfo.label }}</span>
    </div>

    <div class="form-row row light tw-mb-1">
      <label class="col-4">{{ $t("device.lastCommunication") }}</label>
      <div class="form-label col">
        {{ formatTime(device.dh_last_detection) }}
      </div>
    </div>

    <div class="form-row row light tw-mb-1">
      <label class="col-4">{{ $t("device.idButton") }}</label>
      <div class="form-label col text-mono">
        {{ device.mac }}
      </div>
    </div>

    <div class="form-row row light d-flex align-items-center tw-mb-0">
      <label class="col-4">
        <span>{{ $t("device.batteryLvl") }}</span>
      </label>

      <Battery class="bracelet-battery m-0" :level="device.current_battery_level"/>

      <div class="col line-height-tight ml-1">
        <span class="text-mono">{{ device.current_battery_level }}%</span>
      </div>
    </div>

    <div v-if="device.firmware_version" class="form-row row light tw-mb-1">
      <label class="col-4">{{ $t("device.firmware_version") }}</label>
      <div class="form-label col text-mono">
        {{ device.firmware_version	 }}
      </div>
    </div>

    <component :is="accessoryInfo.subComponents" :accesory="device"></component>

  </div>

</template>

<script>
import Icat01 from "./accessory/Icat01.vue";
import Battery from "../icons/Battery.vue";
import moment from "moment/moment";
import Utils from "@/services/utils.js";


export default {
  components: {Battery, Icat01},
  props: {
    accessoryData: {
      type: Object,
      required: true,
    },
    accessoryType: {
      type: String,
      required: true,
    }
  },
  methods: {
    formatTime(time) {
      return time ? moment(time).format("DD/MM/YYYY à HH:mm") : null;
    },
  },
  computed: {
    accessoryInfo() {
      return Utils.getAccessoryInformation(this.$props.accessoryType)
    },

    device() {
      return this.$props.accessoryData
    }
  }
};

</script>